import React, { useContext, useEffect, useState } from 'react';
import styles from './styles.module.scss';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AppContext from '../../hooks/appContext';
import placeholder from '../../assets/img/placeholder.svg';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { formatMoney, capFirstLetter } from '../../utils/helpers';
import Image from 'next/image';

import DOMPurify from 'dompurify';
import config from '@/config';
import { useMeta } from '@/contexts/metaContext';
import doToast from '../doToast/doToast';

const ProductModal = (props) => {
  const {
    cart,
    addToCart,
    reduceProductQty,
    removeFromCart,
    setProductModalShow,
    openCartModal,
    currentCurrency,
    getCurrentCurrencySign,
    activeAttributes,
    setActiveAttributes,
  } = useContext(AppContext);

  const { metaValues } = useMeta();
  // console.log(metaValues);

  const getMerchantId = () => {
    // console.log(window.location.href)
    let fullUrl = window.location.href;
    let n = fullUrl.lastIndexOf('/');
    let merchantId = fullUrl.substring(n + 1);
    return merchantId;
  };

  const [inCart, setInCart] = useState(false);
  const [itemQty, setItemQty] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeColor, setActiveColor] = useState('white');
  const [activeSize, setActiveSize] = useState('38');
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    if (props?.product?.images && props?.product?.images?.length > 0) {
      setSelectedImage(props?.product?.images[0]?.url);
    } else {
      setSelectedImage(placeholder);
    }
  }, [props?.product, props?.show]);

  useEffect(() => {
    const found = cart.some((el) => el.id === props.product.id);
    if (found) {
      const cartProduct = cart.filter((e) => e.id === props.product.id);
      setItemQty(cartProduct[0].qty);
      setInCart(true);
    } else {
      setItemQty(0);
      setInCart(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart, props]);

  const showHideClassName = props.show
    ? `${styles.modal} ${styles['display-block']}`
    : `${styles.modal} ${styles['display-none']}`;

  const sanitizeHtml = (input) => {
    if (typeof window !== 'undefined' && input) {
      return DOMPurify.sanitize(input);
    }
    return '';
  };

  const sendToCart = () => {
    // props.handleClose();
    const newMatchingVariants = activeAttributes?.filter((item) => item.slug === props.product.slug);
    let thisProduct = props.product;
    if (newMatchingVariants.length > 0) {
      thisProduct.matchingVariant = newMatchingVariants;
    }

    addToCart(thisProduct);
    setItemQty(itemQty + 1);

    doToast('Added to cart!', 'success');
    setProductModalShow(false);
  };

  const buyNow = () => {
    const found = cart.some((el) => el.id === props.product.id);
    if (found) {
      openCartModal();
      setProductModalShow(false);
    } else {
      addToCart(props.product);
      openCartModal();
      setProductModalShow(false);
    }
  };

  const addQuantity = (product) => {
    const newMatchingVariants = activeAttributes?.filter((item) => item.slug === product.slug);
    let thisProduct = props.product;
    thisProduct.matchingVariant = newMatchingVariants;

    addToCart(thisProduct);
    setItemQty(itemQty + 1);
  };

  const reduceQuantity = (product) => {
    const newMatchingVariants = activeAttributes?.filter((item) => item.slug === product.slug);
    let thisProduct = props.product;
    thisProduct.matchingVariant = newMatchingVariants;

    reduceProductQty(product);
    setItemQty(itemQty - 1);
  };

  const removeItem = (product) => {
    removeFromCart(product);
    setItemQty(itemQty - 1);
  };

  const getCurrentAmount = (amounts) => {
    const targetObject = amounts?.find((obj) => obj.currency_id === currentCurrency);
    return targetObject?.amount;
  };

  const findVariantAmounts = (product) => {
    if (!product?.variants?.length > 0) {
      return formatMoney(product?.amounts?.find((obj) => obj.currency_id === currentCurrency)?.amount / 100);
    }

    const productAttributes = activeAttributes.filter((attribute) => attribute.slug === product.slug);
    const matchingObject = product?.variants?.find((item) => {
      return productAttributes.every((inputItem) => {
        return item.options.some((option) => option.label === inputItem.label && option.value === inputItem.value);
      });
    });

    return formatMoney(matchingObject?.amounts?.find((obj) => obj.currency_id === currentCurrency)?.amount / 100);
  };

  useEffect(() => {
    if (props?.product?.attributes?.length > 0) {
      const newArray = props?.product?.attributes?.map(({ label, options }) => {
        return { label, value: options[0], slug: props?.product.slug, name: props?.product.name };
      });

      const filteredList = activeAttributes.filter((obj) => obj.slug !== props?.product?.slug);
      const joinedList = [...filteredList, ...newArray];

      setActiveAttributes(joinedList);
    }
  }, [props?.product?.attributes]);

  const setActiveAttr = (label, attrOption) => {
    const newObject = {
      label: label,
      value: attrOption,
      slug: props?.product.slug,
      name: props?.product.name,
    };

    const newArray = activeAttributes.map((obj) => {
      if (obj.label === label && obj.slug === props?.product?.slug) {
        return newObject;
      }
      return obj;
    });

    setActiveAttributes(newArray);
  };

  const faveProduct = (condition) => {
    setIsFavorite(condition);
    const favorites = localStorage.getItem('storefrontFavorites');
    let faveArray = JSON.parse(favorites);

    if (faveArray && faveArray.length > 0) {
      if (faveArray.includes(props?.product?.slug)) {
        const newArray = faveArray.filter((element) => element !== props?.product?.slug);

        const newFavorites = JSON.stringify(newArray);
        localStorage.setItem('storefrontFavorites', newFavorites);
      } else {
        const newArray = faveArray.concat(props?.product?.slug);
        const newFavorites = JSON.stringify(newArray);
        localStorage.setItem('storefrontFavorites', newFavorites);
      }
    } else {
      const newFaveArray = [props?.product?.slug];
      const stringifiedArray = JSON.stringify(newFaveArray);
      localStorage.setItem('storefrontFavorites', stringifiedArray);
    }
  };

  useEffect(() => {
    const favorites = localStorage.getItem('storefrontFavorites');
    let faveArray = JSON.parse(favorites);

    if (favorites && favorites.length > 0) {
      if (faveArray?.includes(props?.product?.slug)) {
        setIsFavorite(true);
      } else {
        setIsFavorite(false);
      }
    }
  }, [props?.product?.slug, props?.show]);

  return (
    <div className={showHideClassName}>
      <section className={styles['modal-main']}>
        <div className={styles['close-box']}>
          <button type={styles.button} onClick={props.handleClose} className={styles['btn-modal-close']}>
            <CloseOutlinedIcon className={styles['btn-modal-close-icon']} />
          </button>
        </div>

        <div className={styles['modal-content']}>
          <div className={styles['modal-images']}>
            <div className={styles['modal-image']}>
              {props.product?.images ? (
                <Image
                  alt=""
                  src={selectedImage ? selectedImage : placeholder}
                  className={styles['product-img']}
                  layout="fill"
                />
              ) : (
                <Image alt="" width={600} height={600} src={placeholder} className={styles['product-img']} />
              )}
            </div>
            {props.product?.images?.length > 1 ? (
              <div className={styles['product-gallery']}>
                {props.product?.images?.map((image, index) => (
                  <div
                    className={styles['gallery-single']}
                    onClick={() => setSelectedImage(image.url)}
                    key={'image' + index}
                  >
                    <Image
                      src={image.url}
                      alt=""
                      layout="fill"
                      className={`${styles['gallery-img']} ${image.url === selectedImage ? styles.active : ''}`}
                    />
                  </div>
                ))}
              </div>
            ) : null}

            <div className={styles.share_social}>
              <div className={styles.share_title}>Share with Customers</div>
              <div className={styles.share_networks}>
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=${config.CHECKOUT}/storefront/${getMerchantId()}`}
                  target={'_blank'}
                  className={styles.social_icon}
                >
                  <FacebookOutlinedIcon className={styles.icon_img} />
                </a>
                <a
                  href={`https://twitter.com/intent/tweet?url=${config.CHECKOUT}/storefront/${getMerchantId()}`}
                  target={'_blank'}
                  className={styles.social_icon}
                >
                  <TwitterIcon className={styles.icon_img} />
                </a>
                <a
                  href={`https://api.whatsapp.com/send?text=${config.CHECKOUT}/storefront/${getMerchantId()}`}
                  target={'_blank'}
                  className={styles.social_icon}
                >
                  <WhatsAppIcon className={styles.icon_img} />
                </a>
                <a
                  href={`mailto:?subject=Storefront link&body=Shop at ${config.CHECKOUT}/storefront/${getMerchantId()}`}
                  target={'_blank'}
                  className={styles.social_icon}
                >
                  <EmailIcon className={styles.icon_img} />
                </a>
              </div>
            </div>
          </div>

          <div className={styles['modal-details']}>
            <div className={styles.details_top_bar}>
              <div className={styles.top_bar_left}>
                <div className={styles['product-title']}>{props.product.name}</div>
                <div className={styles.product_price}>
                  {getCurrentCurrencySign()} {findVariantAmounts(props.product)}
                </div>
              </div>

              <div className={styles.top_bar_right}>
                <div className={styles['purchase-btns']}>
                  {inCart && !props.product.variants.length > 0 ? (
                    <div className={styles['cart-item-actions']}>
                      <div className={styles['item-math']}>
                        <div className={styles['item-minus']} onClick={() => reduceQuantity(props.product)}>
                          <RemoveIcon />
                        </div>
                        <div className={styles['item-qty']}>{itemQty}</div>
                        <div className={styles['item-plus']} onClick={() => addQuantity(props.product)}>
                          <AddIcon />
                        </div>
                      </div>

                      <div className={styles['item-remove']} onClick={() => removeItem(props.product)}>
                        <DeleteOutlineIcon />
                      </div>
                    </div>
                  ) : (
                    <button type="button" className={styles['btn-modal-cart']} onClick={sendToCart}>
                      Add to cart
                    </button>
                  )}
                  {/*<button type='button' className={styles['btn-buy-now']} onClick={buyNow}>Buy Now</button>*/}

                  <div className={styles.fav_button}>
                    <div className={styles.heart_icon}></div>
                    {isFavorite ? (
                      <div className={styles.fav_text} onClick={() => faveProduct(false)}>
                        <div className={styles.saved_box}>
                          {' '}
                          <FavoriteIcon className={styles.fav_text_icon_saved} />{' '}
                        </div>
                        Saved
                      </div>
                    ) : (
                      <div className={styles.fav_text} onClick={() => faveProduct(true)}>
                        <FavoriteBorderIcon className={styles.fav_text_icon} />
                        Add to favorites
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.details_divider}></div>

            {props?.product?.attributes ? (
              <>
                <div className={styles.details_middle_bar}>
                  {props?.product?.attributes.map((attribute, id) => {
                    return (
                      <div className={styles.attribute_row} key={'attr' + id}>
                        <p className={styles.attribute_title}>{capFirstLetter(attribute?.label)}: </p>
                        <div className={styles.attribute_values}>
                          {attribute?.options?.map((option, id) => {
                            return (
                              <div
                                className={`${styles.value_single} ${
                                  activeAttributes.some(
                                    (obj) =>
                                      obj.label === attribute.label &&
                                      obj.value === option &&
                                      obj.slug === props?.product?.slug
                                  )
                                    ? styles.active
                                    : ''
                                }`}
                                onClick={() => setActiveAttr(attribute?.label, option)}
                                key={'option' + id}
                              >
                                {capFirstLetter(option)}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className={styles.details_divider}></div>
              </>
            ) : null}

            <div className={styles.details_bottom_bar}>
              <p className={styles.description_title}>Product Description</p>
              <div
                className={styles['product-desc']}
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(props?.product?.description) }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductModal;
